import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { SimplePersistence } from "../utils";
import { SIGNIN_TOKEN } from "../constants";

const storage = new SimplePersistence();
const isSignedIn = (user) => user && user.isSignedIn && !!storage.getItem(SIGNIN_TOKEN);

export const RequireAuth = ({ children }) => {
  const user = useSelector((state) => state.user);
  const location = useLocation();

  if (!isSignedIn(user)) {
    return (
      <Navigate
        to="/login"
        state={{ from: location }}
        replace
      />
    );
  }

  return children;
};